// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ee2425fe","32":"362fab8a"}[chunkId] + ".chunk.js";
};